import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { SpecilityProvider } from "./context/SpecilityContext";
import { CPTCodesProvider } from "./context/CPTCodesContext";
import { ICDCodesProvider } from "./context/ICDCodesContext";

ReactDOM.render(
  <SpecilityProvider>
    <CPTCodesProvider>
      <ICDCodesProvider>
        <App />
      </ICDCodesProvider>
    </CPTCodesProvider>
  </SpecilityProvider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
